import { useEffect, useState, useMemo } from "react";
import { NavBar, PageHeader, PageHeaderProvider, AppSwitcher } from "@iq/models";
import { TbLayoutDashboard } from "react-icons/tb";
import { FiFileText, FiMessageSquare } from "react-icons/fi";
import { GoHome } from "react-icons/go";
import AppUserMenu from "../components/AppUserMenu";
import HeaderClockAction from "../components/HeaderClockAction";
import useAuthStore from "../states/authStore";

import Dashboard from "./pages/Dashboard";
import Invoices from "./pages/Invoices";
import Payments from "./pages/Payments";
import Quotes from "./pages/Quotes";
import ClientDetail from "./pages/clients/[id]";

import CRMLogo from "../assets/icons/CRM_logo.svg";
import TicketsLogo from "../assets/icons/Tickets_logo.svg";
import AdminLogo from "../assets/icons/Admin_logo.svg";

const paymentNavItems = [
	{ id: "dashboard", label: "Dashboard", icon: <TbLayoutDashboard size={24} /> },
    { id: "payments", label: "Payments", icon: <FiFileText size={24} /> },
	{ id: "invoice", label: "Invoices", icon: <FiFileText size={24} /> },
   
	{ id: "quote", label: "Quote", icon: <FiMessageSquare size={24} /> },
];

const PAYMENT_PAGE_HEADER_TITLES = {
	Dashboard: "Dashboard",
	Payments: "Payments",
	Invoices: "Invoices",
	Quote: "Quotes",
};

function PaymentMain() {
	const appLinks = useMemo(() => ([
        { label: "CRM", image: CRMLogo, href: "/contacts", variant: "crm" },
        { label: "Tickets", image: TicketsLogo, href: "/IT", variant: "tickets" },
        { label: "Admin", image: AdminLogo, href: "/admin", variant: "admin" },
        { label: "Projects", image: AdminLogo, href: "/projects", variant: "projects" },
        { label: "Payment", image: AdminLogo, href: "/payment", variant: "payment" },
    ]), []);

  const [activePage, setActivePage] = useState("Dashboard");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedClientPreview, setSelectedClientPreview] = useState(null);
  const profile = useAuthStore((state) => state.profile);
  const profileName = profile?.name ?? "User";
  const profileId = profile?.id ?? null;
  const [pageHeader, setPageHeader] = useState({
	title: PAYMENT_PAGE_HEADER_TITLES.Dashboard,
	back: false,
	onBack: null,
	children: null,
  });

  function handleBackFromClient() {
	setSelectedClientId(null);
	setSelectedClientPreview(null);
  }

  useEffect(() => {
	if (selectedClientId) {
		setPageHeader({
			title: selectedClientPreview?.name || "Client",
			back: true,
			onBack: handleBackFromClient,
			children: null,
		});
		return;
	}

	setPageHeader({
		title: PAYMENT_PAGE_HEADER_TITLES[activePage] || PAYMENT_PAGE_HEADER_TITLES.Dashboard,
		back: false,
		onBack: null,
		children: null,
	});
  }, [activePage, selectedClientId, selectedClientPreview]);

  function renderPage() {
    if (selectedClientId) {
      return (
        <ClientDetail
					setPageHeader={setPageHeader}
          clientId={selectedClientId}
					initialClient={selectedClientPreview}
					onBack={handleBackFromClient}
        />
      );
    }

    switch (activePage) {
      case "Dashboard":
	        return <Dashboard onClientSelect={(client) => {
			setSelectedClientPreview(client || null);
			setSelectedClientId(client?.id || null);
		}} />;
      case "Payments":
	        return <Payments />;
      case "Invoices":
	        return <Invoices />;
      case "Quote":
	        return <Quotes />;
      default:
	        return <Dashboard />;
    }
  }

  return (
		<div className="crm-layout app">
			<div className="nav-section">
				<NavBar
					activePage={activePage}
					navItems={paymentNavItems}
					onPageChange={(page) => {
						setSelectedClientId(null);
						setSelectedClientPreview(null);
						setActivePage(page);
					}}
					footerAction={{
						label: "Home",
						icon: <GoHome size={24} />,
						onClick: () => {
							window.location.href = "/";
						},
					}}
				/>
			</div>
			<PageHeaderProvider userMenu={(
				<>
					<HeaderClockAction />
					<AppSwitcher apps={appLinks} activeLabel="Home" />
					<AppUserMenu name={profileName} id={profileId} />
				</>
			)}
			>
				<PageHeader title={pageHeader.title} back={pageHeader.back} onBack={pageHeader.onBack}>
					{pageHeader.children}
				</PageHeader>
				{renderPage()}
			</PageHeaderProvider>
		</div>
	);
}

export default PaymentMain;